import { QUERYPARAMS, DRAWERS } from 'config/environments/shared';
import { getPaymentStatus } from 'helpers';
import { usePaymentDetail, useDrawer, useTracking } from 'hooks';

import { HeaderContent } from '../HeaderContent';

import type { THeaderContentPayment } from '../Drawers.components.d';

export const HeaderContentPayment = ({ title, isToBack, ...props }: THeaderContentPayment) => {
  const { searchParams } = useDrawer(DRAWERS.PAYMENT_DETAIL);
  const { data, isEudoraVdfPayment } = usePaymentDetail(
    searchParams.get(QUERYPARAMS.PAYMENT_ID) ?? ''
  );
  const { sendDataToGTM } = useTracking();
  const brand = isEudoraVdfPayment ? 'eudora' : 'boticario';

  const paymentStatus = getPaymentStatus({
    daysLate: data?.daysLate ?? 0,
    daysUntilDueDate: data?.daysUntilDueDate ?? 0,
    paymentStatus: data?.paymentStatus ?? '',
    status: data?.status ?? '',
  });

  const handleDrawer = () => {
    sendDataToGTM({
      event: 'analytics-event', // always this event name
      event_parameters: {
        event_name: 'interaction_detalhes_pagamento',
        cd_interaction_detail: `${brand}:click:fechar-drawer`,
        transaction_id: data?.orderId,
        cd_metodo_pagamento: data?.planDetail.toLowerCase(),
        cd_status_pagamento: paymentStatus?.tag.toLowerCase(),
        cd_dias_para_vencimento: data?.daysUntilDueDate,
        cd_dias_apos_vencimento: data?.daysLate,
      },
    });
  };

  return (
    <HeaderContent title={title} isToBack={isToBack} {...props} onCloseCallback={handleDrawer} />
  );
};
